export const ErrorBox = ({errors}) => {
    return (
    errors ? <div
        className="flex items-center gap-2 p-2.5 mt-2 text-xs text-red-700 rounded-lg bg-gradient-to-r from-red-50 to-rose-50 border border-red-300 dark:bg-gray-800 dark:text-red-400 dark:border-red-700 animate-[shake_0.3s_ease-in-out] shadow-sm"
        role="alert"
      >
        <svg
          className="flex-shrink-0 w-4 h-4"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
        </svg>
        <span className="sr-only">Error</span>
        <div className="font-semibold">
          {errors.message}
        </div>
      </div> : '' );

}